/* tslint:disable:max-line-length */
import {FuseNavigationItem} from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [];

const mastersChildrenNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards.kpis',
        title: 'KPI´s',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/master/kpis'
    },
    {
        id: 'dashboards.executive',
        title: 'Dashboard Ejecutivo',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-bar',
        link: '/master/executive-dashboard'
    },
    /*{
        id: 'dashboards.users',
        title: 'Todos los Usuarios',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/master/users'
    },*/
    {
        id: 'hotels.downloads',
        title: 'Descarga de información',
        type: 'basic',
        icon: 'heroicons_outline:folder-download',
        link: '/hotels/downloads'
    }, {
        id: 'admin.reports',
        title: 'Reportes',
        type: 'basic',
        icon: 'heroicons_outline:book-open',
        link: '/master/admin-reports'
    }
];

export const masterNavigation: FuseNavigationItem[] = [
    {
        id: 'master',
        title: 'Administración',
        subtitle: 'TAXSAT',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'semiMaster.accounts',
                title: 'Grupos Empresariales',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/master/semi-master-users'
            },
            {
                id: 'master.data',
                title: 'Bases de Datos',
                type: 'collapsable',
                icon: 'heroicons_outline:check-circle',
                children: [
                    {
                        id: 'master.data.icsoe',
                        title: 'ICSOE',
                        type: 'basic',
                        icon: 'heroicons_outline:user-circle',
                        link: '/master/icsoe'
                    }
                ]
            },
            {
                id: 'master.fianzas',
                title: 'Fianzas',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/master/fianzas'
            },
            ...mastersChildrenNavigation,
            {
                id: 'master.polizas',
                title: 'Pólizas proveedores',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/master/polizas'
            }
        ]
    }
];

export const semiMasterNavigation: FuseNavigationItem[] = [
    {
        id: 'master',
        title: 'Administración',
        subtitle: 'TAXSAT',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'semiMaster.fianzas',
                title: 'Fianzas',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/master/fianzas-semi'
            },
            ...mastersChildrenNavigation,
            {
                id: 'semiMaster.polizas',
                title: 'Pólizas proveedores',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/master/polizas'
            }
        ]
    }
];

export const hotelNavigation: FuseNavigationItem[] = [
    {
        id: 'hotels',
        title: 'Compañías',
        subtitle: 'Grupos',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'hotels.providers',
                title: 'Proveedores',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/hotels/providers'
            },
            {
                id: 'hotels.users',
                title: 'Nuevo proveedor',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/hotels/users'
            },
            {
                id: 'hotels.indicators',
                title: 'Indicadores proveedores',
                type: 'basic',
                icon: 'heroicons_outline:document-duplicate',
                link: '/hotels/indicators'
            },
            {
                id: 'hotels.executive',
                title: 'Dashboard Ejecutivo',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-bar',
                link: '/master/executive-dashboard'
            },
            {
                id: 'hotels.downloads',
                title: 'Descarga de información',
                type: 'basic',
                icon: 'heroicons_outline:folder-download',
                link: '/hotels/downloads'
            },
            {
                id: 'hotels.polizas',
                title: 'Pólizas',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/hotels/polizas'
            },
            {
                id: 'hotels.fianzas',
                title: 'Fianzas',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/hotels/fianzas'
            },
            // {
            //    id: 'hotels.refer',
            //  title: 'Refiere y gana',
            //  type: 'basic',
            //  icon: 'heroicons_outline:currency-dollar',
            //  link: '/hotels/refer'
            //  },
            // {
            //     id: 'hotels.incomes',
            //     title: 'CFDIs',
            //     type: 'basic',
            //     icon: 'heroicons_outline:document-duplicate',
            //     link: '/hotels/inout'
            // }, {
            //     id: 'hotels.kpisFact',
            //     title: 'KPIs CFDI',
            //     type: 'basic',
            //     icon: 'heroicons_outline:document-duplicate',
            //     link: '/hotels/kpis'
            // }
        ]
    }
];

/**
 * {
 *                 id: 'hotels.kpis',
 *                 title: 'KPIs',
 *                 type: 'basic',
 *                 icon: 'heroicons_outline:chart-bar',
 *                 link: '/hotels/kpis'
 *             },
 */

export const providerNavigation: FuseNavigationItem[] = [
    {
        id: 'providers',
        title: 'Proveedores',
        subtitle: 'Servicios especializados',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'providers.hotels',
                title: 'Compañías',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/providers/hotels'
            },
            /*{
                id: 'providers.employees',
                title: 'Empleados',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/providers/employees'
            },*/
            {
                id: 'siroc',
                title: 'SIROC',
                type: 'basic',
                icon: 'heroicons_outline:calendar',
                link: '/providers/siroc'
            },
            {
                id: 'providers.documents',
                title: 'Documentación inicial',
                type: 'basic',
                icon: 'heroicons_outline:document',
                link: '/providers/update-init-load'
            },
            {
                id: 'providers',
                title: 'Registro patronal',
                type: 'basic',
                icon: 'heroicons_outline:pencil',
                link: '/providers/imss-employer-registry'
            },
            {
                id: 'providers.polizas',
                title: 'Pólizas',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/providers/polizas'
            }
        ]
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
